import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Podcast promo landing page (daileyphotos.com/analogtalk → photos.dailey.cloud/analogtalk).
// Offer: 25% off any plan for the first 12 months, then reverts to list price.
const PROMO = 'ANALOGTALK';
const PLANS = [
  { id: 'free', name: 'Personal', price: 7, storage: '100 GB', blurb: 'Private photo storage to get started.' },
  { id: 'pro', name: 'Pro', price: 39, storage: '500 GB', blurb: 'Unlimited albums + client sharing.' },
  { id: 'studio', name: 'Studio', price: 99, storage: '2 TB', blurb: 'Client galleries, proofing & The Strip.', featured: true },
  { id: 'business', name: 'Business', price: 179, storage: '5 TB', blurb: 'Team seats, client uploads, priority compute.' },
];

const disc = (p) => (p * 0.75).toFixed(2).replace(/\.00$/, '');

export default function AnalogTalk() {
  // Persist the promo so it survives the signup → checkout hop (incl. abandon → paywall).
  useEffect(() => {
    try { localStorage.setItem('promoCode', PROMO); } catch {}
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 py-12 sm:py-16">
        <div className="text-center mb-10">
          <img src="/favicon/favicon-96x96.png" alt="Photo Harbor" className="h-12 w-auto mx-auto mb-5" />
          <span className="inline-block text-xs font-semibold tracking-wide uppercase bg-blue-100 text-blue-700 rounded-full px-3 py-1 mb-4">
            Analog Talk listeners
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
            25% off your first year of Photo Harbor
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional photo storage built on privacy, not advertising. No AI training, original
            quality, you own your data. Use code <span className="font-mono font-semibold">{PROMO}</span> , 
            it's applied automatically below. 25% off every month for 12 months, then your plan's
            normal price. Cancel anytime.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {PLANS.map((p) => (
            <div
              key={p.id}
              className={`rounded-2xl border bg-white p-5 flex flex-col ${p.featured ? 'border-blue-400 ring-1 ring-blue-200' : 'border-gray-200'}`}
            >
              {p.featured && (
                <span className="self-start text-[11px] font-semibold uppercase tracking-wide text-blue-700 mb-1">Most popular</span>
              )}
              <h3 className="text-lg font-bold text-gray-900">{p.name}</h3>
              <p className="text-sm text-gray-500 mb-3">{p.storage}</p>
              <div className="mb-1">
                <span className="text-3xl font-bold text-gray-900">${disc(p.price)}</span>
                <span className="text-gray-500">/mo</span>
              </div>
              <p className="text-xs text-gray-400 mb-3">
                <span className="line-through">${p.price}/mo</span> for 12 months, then ${p.price}/mo
              </p>
              <p className="text-sm text-gray-600 mb-5 flex-1">{p.blurb}</p>
              <Link
                to={`/login?mode=signup&promo=${PROMO}&plan=${p.id}`}
                className={`block text-center py-2.5 rounded-lg font-medium ${p.featured ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`}
              >
                Get {p.name}
              </Link>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-gray-400 mt-8">
          Discount applies for 12 months from signup, then your plan renews at its standard monthly
          price. A payment method is required to start. Cancel anytime from Settings.
        </p>
      </div>
    </div>
  );
}
